<template>
  <div class="login">
    <div style="color: red;">
      保密提示：本平台为非涉密信息系统，严禁处理、传输国家秘密，禁止转发内部文件。
    </div>
    <div class="top-logo">
      <img class="logo" :src="logo">
      <div class="sub-title">
        <span>欢迎登录</span>
        <span class="sub-title-high">
        “
          <img src="../../assets/login/logo-text.png">
        ”
        </span>
      </div>
      <p>浙江省消防救援总队财务数字化管理平台</p>
    </div>
    <div class="login-type">
      <div class="login-type-container">
        <div class="go-admin go-two-admin" @click="login(2)">
          <img class="two-level" src="../../assets/login/two-level.png">
          <span>系统管理员</span>
        </div>
        <div class="go-admin" @click="login(4)">
          <img class="finance" src="../../assets/login/finance.png">
          <span>财务人员</span>
        </div>
      </div>
      <div class="first-admin">
        <span>我是一级管理员，点此</span>
        <span class="login-text" @click="login(1)">登录</span>
      </div>
    </div>
    <copy-right />
  </div>
</template>

<script>
import dd from 'gdt-jsapi';
import { config } from '@/common/js/config.js'
import { saveToken, saveAdminType, saveUserName, saveIsAdmin, saveTwolevelAuthrity,
getAdminType, saveTeamId, saveLoginImg, saveZzd, savedAministerLevel } from "common/js/storage";
import User from "@/models/user.js";
import Staff from "@/models/staff.js";
import CopyRight from "@/components/copy-right";
import Administrator from "@/models/administrator.js";
export default {
  components: {
    CopyRight
  },

  data() {
    return {
      logo: require('../../assets/fire-logo.png'),
    }
  },

  created() {
    config()
  },

  methods: {
    login(type) {
      // 196729
      //测试上需要注释 corpId；
      // let corpId = "196729" //浙政钉租户ID，不是专有钉钉租户id
      dd.ready(() => {
        dd.getAuthCode({
          // corpId
        }).then(res => {
            let code = res.auth_code; // 通过该免登授权码可以获取用户身份
            if (type === getAdminType()) {
              saveIsAdmin(true)
            } else {
              saveIsAdmin(false)
            }
            User.login(code, type).then(res => {
              if (res.success) {
                this.loginFinish(res);
              } else {
                this.$message({
                  type: 'error',
                  message: res.message
                });
              }
          });
        })
      });
    },
    /**
     * 登录成功回调方法
     * @param res 返回的参数
     *
     */
    loginFinish(res){
      saveToken(res.result.token);
      saveAdminType(res.result.adminType);
      saveUserName(res.result.username)
      saveTeamId(res.result.teamId)
      saveLoginImg(res.result.image)
      saveZzd(res.result.zzdId)
      sensors_sw.login(res.result.zzdId);
      savedAministerLevel(res.result.administerLevel)
      if (res.result.adminType === 1) {
        this.$router.replace("/oneLevel");
      } else if(res.result.adminType === 4) {
        this.$router.replace("/finance");
      } else {
        this.initTwolevelAuthority()
      }
    },

    async initTwolevelAuthority() {
      let res = await Administrator.getTwolevelAuthority()
      if (res.success) {
        await saveTwolevelAuthrity(res.result);
        await this.$router.replace("/fire");
      } else {
        this.$message.error(res.message)
      }
    }
  }
}
</script>

<style lang='scss'>
.login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url('../../assets/login/bg-login.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  .top-logo {
    font-size: $fs-medium-l;
    font-weight: 400;
    color: $color-grey;
    .logo {
      width: 78px;
      height: 84px;
      margin-bottom: 36px;
    }
    .sub-title {
      font-size: $fs-medium-l;
      color: $color-BlackGrey;
      margin-bottom: 20px;
    }
    p {
      color: $color-BlackGrey;
    }
    .sub-title-high {
      img {
        width: 70px;
        height: 23px;
      }
    }
  }
  .login-type {
    @include flex-column-center;
    .login-type-container {
      @include flex-start;
      .go-admin {
        width: 200px;
        height: 36px;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid $bg-DeepReddishBlue;
        border-radius: 4px;
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-DeepReddishBlue;
        cursor: pointer;
        @include flex-center;
        .two-level {
          width: 17px;
          height: 18px;
          margin-right: 13px;
        }
        .finance {
          width: 16px;
          height: 18px;
          margin-right: 12px;
        }
      }
      .go-two-admin {
        margin-right: 20px;
      }
    }
    .first-admin {
      font-size: $fs-medium-s;
      font-weight: 400;
      color: $color-LightGrey;
      margin-top: 50px;
      .login-text {
        cursor: pointer;
        color: $color-DeepReddishBlue;
      }
    }
  }
}
</style>
